import React, { useState } from "react";
import { useApp } from "context";

import { Grid, Typography } from "@mui/material";
import { Card } from "components";
import { Helpers } from "utils";

type Props = {};

export const Home = (props: Props) => {
  const { t, theme, user } = useApp();

  const [bigCalendarOpened, setBigCalendarOpened] = useState(true);
  const [health360Opened, setHealth360Opened] = useState(false);

  return (
    <>
      <div className="qh-header">
        <Grid container spacing={theme.margin.md}>
          <Grid container item xs={12} sm={6}>
            <div className="qh-title">
              <Typography
                component="span"
                sx={{ fontSize: theme.font.md, marginRight: theme.margin.sm }}
              >
                {Helpers.interpolate(t.message.greeting[Helpers.greeting()], {
                  username: user.username,
                })}
              </Typography>
            </div>
          </Grid>
          <Grid container item xs={12} sm={6} justifyContent="flex-end">
            <div className="qh-control"></div>
          </Grid>
        </Grid>
      </div>
      <div className="qh-content">
        <Grid container spacing={theme.margin.md}>
          <Grid item xs={12}>
            <Card.BigCalendar
              opened={bigCalendarOpened}
              toggle={() => setBigCalendarOpened(!bigCalendarOpened)}
            />
          </Grid>
          <Grid item xs={12}>
            <Card.Health360
              opened={health360Opened}
              toggle={() => setHealth360Opened(!health360Opened)}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
